import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const categoryBanners: Record<string, string> = {
  dianying: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20movie%20theater%20scene%20with%20film%20reel%20and%20popcorn%2C%20dark%20red%20velvet%20curtains%2C%20soft%20golden%20spotlight%2C%20elegant%20minimalist%20composition&width=640&height=384&seq=cat-banner-dianying&orientation=landscape",
  dianshiju: "https://readdy.ai/api/search-image?query=Cozy%20living%20room%20with%20large%20TV%20screen%20displaying%20drama%20series%2C%20warm%20lamplight%2C%20comfortable%20sofa%2C%20modern%20home%20interior%2C%20cinematic%20mood&width=640&height=384&seq=cat-banner-dianshiju&orientation=landscape",
  zongyi: "https://readdy.ai/api/search-image?query=Bright%20colorful%20TV%20show%20stage%20with%20vibrant%20neon%20lights%2C%20entertainment%20atmosphere%2C%20cheerful%20party%20vibe%2C%20warm%20and%20energetic%20composition&width=640&height=384&seq=cat-banner-zongyi&orientation=landscape",
  dongman: "https://readdy.ai/api/search-image?query=Artistic%20anime%20style%20illustration%20display%20with%20vibrant%20colors%2C%20manga%20books%20and%20figurines%2C%20warm%20desk%20lamp%20lighting%2C%20creative%20studio%20atmosphere&width=640&height=384&seq=cat-banner-dongman&orientation=landscape",
  jilupian: "https://readdy.ai/api/search-image?query=Stunning%20nature%20landscape%20with%20golden%20sunset%20over%20mountains%2C%20documentary%20cinematography%20style%2C%20warm%20natural%20light%2C%20vast%20wilderness%20panorama&width=640&height=384&seq=cat-banner-jilupian&orientation=landscape",
  tiyu: "https://readdy.ai/api/search-image?query=Dynamic%20sports%20arena%20with%20dramatic%20stadium%20lights%2C%20athletes%20in%20motion%2C%20exciting%20competition%20atmosphere%2C%20warm%20golden%20hour%20lighting&width=640&height=384&seq=cat-banner-tiyu&orientation=landscape",
  yinyue: "https://readdy.ai/api/search-image?query=Elegant%20music%20concert%20stage%20with%20warm%20spotlight%2C%20grand%20piano%2C%20classical%20instrument%20details%2C%20sophisticated%20golden%20and%20amber%20tones&width=640&height=384&seq=cat-banner-yinyue&orientation=landscape",
  youxi: "https://readdy.ai/api/search-image?query=Futuristic%20gaming%20setup%20with%20RGB%20lighting%2C%20mechanical%20keyboard%20and%20headset%2C%20immersive%20gaming%20atmosphere%2C%20warm%20accent%20lights%20in%20dark%20room&width=640&height=384&seq=cat-banner-youxip&orientation=landscape",
};

export default function CategorySection() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            探索视频分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            八大热门分类，精选海量内容，找到你喜欢的每一部视频
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2 mb-10">
          {categories.map((cat, index) => (
            <button
              key={cat.slug}
              onClick={() => setActiveIndex(index)}
              onMouseEnter={() => setActiveIndex(index)}
              className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeIndex === index
                  ? 'bg-primary-500 text-background-50 shadow-sm'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </button>
          ))}
        </div>

        {categories.map((cat, index) => (
          <div
            key={cat.slug}
            className={`transition-all duration-300 ${
              activeIndex === index ? 'block' : 'hidden'
            }`}
          >
            <div className="flex flex-col lg:flex-row items-center gap-8 bg-background-50 rounded-xl p-6 md:p-8">
              <div className="w-full lg:w-80 h-48 rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src={categoryBanners[cat.slug]}
                  alt={cat.name}
                  title={`${cat.name} - 91视频分类`}
                  className="w-full h-full object-cover rounded-lg"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 text-center lg:text-left">
                <h3 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-3">
                  <i className={`${cat.icon} text-primary-500 mr-2`}></i>
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 mb-4 leading-relaxed">{cat.description}</p>
                <div className="flex items-center justify-center lg:justify-start gap-6 mb-5">
                  <span className="text-sm text-foreground-500">
                    <strong className="text-primary-600 text-lg">{cat.count.toLocaleString()}</strong> 部视频
                  </span>
                </div>
                <Link
                  to={`/category/${cat.slug}`}
                  className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  浏览全部
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}